import { useEffect, useState } from 'react';

/**
 * @param {*} ref refrenece
 * @returns {array} state
 */
interface OutsideAlerterProps {
    current: HTMLElement | null;
}

interface HandleClickOutsideEvent extends Event {
    target: EventTarget | null;
}

export function useOutsideAlerter(ref: OutsideAlerterProps): [boolean] {
    const [panel, setPanel] = useState<boolean>(false);
    useEffect(() => {
        /**
         * @param {HandleClickOutsideEvent} event html event
         */
        function handleClickOutside(event: HandleClickOutsideEvent): void {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setPanel(!panel);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, panel]);
    return [panel];
}
